// @ts-nocheck
import {Button} from 'antd';
import { loginRequest } from 'authConfig';
import { updateAppState } from 'models/subscriptions/reducer';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getMsalInstance } from 'utils/msalInstance';

export const SignOutButton = () => {
	const instance = getMsalInstance();

	const handleLogout = logoutType => {
		if (logoutType === 'popup') {
			instance.logoutPopup({
				postLogoutRedirectUri: '/',
				mainWindowRedirectUri: '/' // redirects the top level app after logout
			});
		}
	};

	return (
		<Button onClick={() => handleLogout('popup')} type="primary" block>
			Sign out
		</Button>
	);
};

export const SignInButton = () => {
	const instance = getMsalInstance();

	const dispatch = useDispatch();
	const handleLogin = async loginType => {
		if (loginType === 'popup') {
			await instance
				.loginPopup(loginRequest)
				.then(a => {
					localStorage.removeItem('urlKey');

					dispatch(
						updateAppState({
							isLoggedOutUser: false,
							isInvalidUser: false
						})
					);
				})
				.catch(e => {
					localStorage.removeItem('urlKey');
					localStorage.clear();
					console.log(e);
				});
		}
	};
	return <Button size='large' onClick={() => handleLogin('popup')} type="primary" block>Sign in</Button>;
};
